import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function BusinessVerification() {
	return (
		<>
			<Helmet>
				<title>Business Verification | Apex Specialty Contracting LLC</title>
				<meta name="description" content="Verification details for Apex Specialty Contracting LLC: FL roofing contractor license, insurance, and business credentials." />
			</Helmet>
			<PageHeader
				title="Business Verification"
				subtitle="Credentials and licensing information for Apex Specialty Contracting LLC."
			/>
			<section className="section">
				<div className="container" style={{ maxWidth: 780 }}>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 14px' }}>Business Identity</h3>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['Legal Name', 'APEX SPECIALTY CONTRACTING LLC'],
									['DBA / Trade Name', 'Apex Specialty Contracting'],
									['Business Type', 'Limited Liability Company (LLC)'],
									['State of Formation', 'Florida, USA'],
									['Industry', 'Roofing &amp; Storm Restoration Contracting'],
									['Address', '183 Highland Rd, Tarpon Springs, FL 34689'],
									['Phone', '(916) 316-0696'],
									['Email', 'info@appexconnecthub.com'],
									['Website', 'appexconnecthub.com'],
								].map(([label, value]) => (
									<tr key={label} style={{ borderBottom: '1px solid #e6eeeb' }}>
										<td style={{ padding: '8px 0', fontWeight: 600, color: '#444', width: '40%' }}
											dangerouslySetInnerHTML={{ __html: label }} />
										<td style={{ padding: '8px 0' }}
											dangerouslySetInnerHTML={{ __html: value }} />
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 14px' }}>Licensing &amp; Insurance</h3>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['FL Contractor License', '#XXXXX2536 — Certified Roofing Contractor'],
									['Issued By', 'Florida Dept. of Business &amp; Professional Regulation (DBPR)'],
									['General Liability', '$2,000,000 per occurrence'],
									['Workers&apos; Compensation', 'Full coverage on all employees and supervised subcontractors'],
								].map(([label, value]) => (
									<tr key={label} style={{ borderBottom: '1px solid #e6eeeb' }}>
										<td style={{ padding: '8px 0', fontWeight: 600, color: '#444', width: '40%' }}
											dangerouslySetInnerHTML={{ __html: label }} />
										<td style={{ padding: '8px 0' }}
											dangerouslySetInnerHTML={{ __html: value }} />
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 10px' }}>Nature of Business</h3>
						<p className="helper" style={{ margin: '0 0 8px' }}>
							Apex Specialty Contracting LLC is a Florida-licensed roofing contractor serving residential and
							commercial customers throughout the Tampa Bay area. We perform roof replacements, storm damage
							repairs, insurance claims assistance, free inspections, gutter installation, and commercial roofing
							(TPO, EPDM, metal systems).
						</p>
						<p className="helper" style={{ margin: 0 }}>
							We communicate with customers via phone, email, and SMS to schedule inspections, confirm appointments,
							send project status updates, and share relevant offers. SMS is used only for contacts who have
							provided explicit written consent.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px' }}>
						<h3 style={{ margin: '0 0 10px' }}>SMS Program Details</h3>
						<p className="helper" style={{ margin: '0 0 8px' }}>
							<strong>Program:</strong> Apex Specialty Contracting marketing &amp; service SMS<br />
							<strong>Types of messages:</strong> estimate reminders, appointment confirmations, project status updates, promotional offers<br />
							<strong>Opt-in method:</strong> Explicit written consent via website contact form<br />
							<strong>Opt-out:</strong> Reply STOP to any message; or use our online opt-out form<br />
							<strong>Help:</strong> Reply HELP or contact <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a><br />
							<strong>Message frequency:</strong> Varies — typically 2–6 messages per month<br />
							<strong>Rates:</strong> Message and data rates may apply
						</p>
						<p className="helper" style={{ margin: 0, fontStyle: 'italic', fontSize: 12 }}>
							Consent is not required to receive roofing services.
							We do not sell or share mobile numbers with third parties for marketing.
						</p>
					</div>

				</div>
			</section>
		</>
	);
}

export default BusinessVerification;



